import { photoNote } from '@flowology/domain';

/**
 * Whether the customer sees a photo on their portal (attachments.setVisibility, CCP Cam parity): "Office
 * only" when hidden, and the one button that changes it, for the roles that review jobs.
 */
export function PhotoVisibility({
  p,
  busy,
  onSet,
}: {
  p: { visibility: string; caption: string | null; category: string };
  busy: boolean;
  /** Absent: shown, not changed (a role that doesn't review jobs). */
  onSet?: (visibility: 'customer' | 'internal') => void;
}) {
  const hidden = p.visibility === 'internal';
  // its note, never its file's name (P-0161)
  const what = photoNote(p.caption) ?? `${p.category} photo`;
  return (
    <span className="row small">
      {hidden && <span className="chip">Office only</span>}
      {onSet && (
        <button
          className="btn quiet"
          disabled={busy}
          aria-label={`${hidden ? 'Show to the customer' : 'Hide from the customer'}: ${what}`}
          onClick={() => onSet(hidden ? 'customer' : 'internal')}
        >
          {hidden ? 'Show to the customer' : 'Hide from the customer'}
        </button>
      )}
    </span>
  );
}
